import { render, staticRenderFns } from "./root.vue?vue&type=template&id=2d131f38&"
import script from "./root.vue?vue&type=script&lang=ts&"
export * from "./root.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports